<template>
    <v-dialog
        v-model="showDialog"
        width="600px"
        :persistent="loading.save || loading.requestForApproval"
    >
        <v-card>
            <v-form
                v-if="selectedAcu"
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white;">
                    Manage ACU Portal Access Status
                </v-card-title>
                <v-card-text style="height: 70vh; overflow-x: hidden; overflow-y: scroll;">
                    <b>Account Information</b>
                    <v-text-field
                        v-model="data.ACCT_M"
                        readonly
                        label="Account Name"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        class="update-acu-contract-blue-hint"
                        color="teal darken-1"
                    />
                    <v-text-field
                        v-model="data.ACCT_N"
                        readonly
                        label="Account Number"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        class="update-acu-contract-blue-hint"
                        color="teal darken-1"
                    />
                    <v-text-field
                        v-model="data.AEXP_D"
                        type="date"
                        readonly
                        label="Account Expiry"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        class="update-acu-contract-blue-hint"
                        color="teal darken-1"
                    />
                    <v-text-field
                        v-model="data.PDUN_D"
                        type="date"
                        readonly
                        label="Paid Until"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        class="update-acu-contract-blue-hint"
                        color="teal darken-1"
                    />
                    <v-text-field
                        v-model="data.MODE_OF_PAYMENT"
                        readonly
                        label="Mode of Payment"
                        class="update-acu-contract-blue-hint"
                        color="teal darken-1"
                    />
                    <v-text-field
                        v-if="data.GRCP_D"
                        v-model="data.GRCP_D"
                        type="date"
                        readonly
                        label="Grace Period"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        class="update-acu-contract-blue-hint"
                        color="teal darken-1"
                    />
                    <v-text-field
                        v-else
                        v-model="no_grace"
                        readonly
                        label="Grace Period"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        class="update-acu-contract-blue-hint"
                        color="teal darken-1"
                    />
                    <b>Portal ACU Settings</b>
                    <v-select
                        v-model="data.STATUS"
                        :items="['ACTIVE', 'INACTIVE']"
                        label="Status"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                    />
                    <v-select
                        v-model="data.USE_STORED_RATES"
                        :items="['YES', 'NO']"
                        return-object
                        label="Use Stored Rates"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                    />
                    <v-text-field
                        v-model="data.VALIDITY_DAYS"
                        type="number"
                        label="Days of Approval Validity"
                        :rules="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? [()=>true] : rule.days"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                    />
                    <v-text-field
                        ref="statusDate"
                        v-model="data.STATUS_DATE"
                        type="date"
                        label="Portal Active Date"
                        :rules="
                            selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? [()=>true] :
                            [
                                (v) => isDateAllowed(v, switchPaidUntilOrGracePeriod(data.PDUN_D, data.GRCP_D), data.AEXP_D) || 'Must not exceed paid until (or grace period), and account expiry',
                                (v) => isDateAllowed(v, v, data.ACTIVE_UNTIL) || 'Must not exceed active until'
                            ]"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                        @input="handleChangeDate"
                    />
                    <v-text-field
                        ref="activeUntil"
                        v-model="data.ACTIVE_UNTIL"
                        type="date"
                        label="Portal Active Until"
                        :rules="
                            selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? [()=>true] :
                            [
                                (v) => isDateAllowed(v, switchPaidUntilOrGracePeriod(data.PDUN_D, data.GRCP_D), data.AEXP_D) || 'Must not exceed paid until (or grace period), and account expiry'
                            ]"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                        @input="handleChangeDate"
                    />
                    <v-combobox
                        ref="monthsOfContinuousMembership"
                        v-model="data.MEMB_MONTHS"
                        :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        label="No. of Months of Continuous Membership"
                        :rules="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? [()=>true] : rule.month"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                    />
                    <v-combobox
                        ref="monthsOfPayment"
                        v-model="data.PAID_MONTHS"
                        :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        label="No. of Months of Payment"
                        :rules="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? [()=>true] : rule.month"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                    />
                    <v-combobox
                        ref="monthsActiveOnTheCurrentContractPeriod"
                        v-model="data.PAID_MEMB_MONTHS"
                        :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        label="No. of Months Active on the Current Contract Period"
                        :rules="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? [()=>true] : rule.month"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                    />
                    <v-text-field
                        v-model="data.PROVISION_EXPIRY"
                        type="date"
                        label="Provision Expiry Date"
                        :rules="
                            selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? [()=>true] :
                            [
                                (v) => isDateAllowed(v, v, data.AEXP_D) || 'Must not exceed account expiry' // Provision Expiry Date is not dependent on paid until
                            ]"
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                    />
                    <v-textarea
                        v-model="data.INT_REMARKS"
                        label="Internal Remarks"
                        outlined
                        :readonly="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING'"
                        :hint="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'This field becomes editable after moving the item to In Progress' : null"
                        :class="selectedAcu.STATUS === 'ACTIVE' || selectedAcu.STATUS === 'PENDING' ? 'update-acu-contract-blue-hint' : null"
                        color="teal darken-1"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    &nbsp;
                    <v-btn
                        v-if="selectedAcu.STATUS === 'IN PROGRESS'"
                        :loading="loading.save"
                        color="teal darken-1"
                        style="color: white;"
                        @click="handleSaveWhenInProgress"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        save
                    </v-btn>
                    <v-btn
                        v-if="selectedAcu.STATUS === 'IN PROGRESS'"
                        :loading="loading.requestForApproval"
                        color="teal darken-1"
                        style="color: white;"
                        @click="handleRequestForApproval"
                    >
                        <v-icon>{{ mdiCheckDecagram }}</v-icon>
                        request for approval
                    </v-btn>
                    <v-btn
                        v-if="selectedAcu.STATUS === 'INACTIVE'"
                        :loading="loading.save"
                        color="teal darken-1"
                        style="color: white;"
                        type="submit"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        save
                    </v-btn>
                    <v-btn
                        v-if="selectedAcu.STATUS === 'PENDING'"
                        :loading="loading.requestForApproval"
                        color="teal darken-1"
                        style="color: white;"
                        @click="handleMoveToInProgress(true)"
                    >
                        <v-icon>{{ mdiFileMoveOutline }}</v-icon>
                        move to in progress
                    </v-btn>
                    <v-btn
                        v-if="selectedAcu.STATUS === 'ACTIVE'"
                        :loading="loading.requestForApproval"
                        color="teal darken-1"
                        style="color: white;"
                        @click="handleMoveToInProgress(true)"
                    >
                        <v-icon>{{ mdiFileMoveOutline }}</v-icon>
                        move to in progress & edit
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { moment } from '../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiCheck,
    mdiClose,
    mdiCheckDecagram,
    mdiFileMoveOutline
} from '@mdi/js'

export default {
    props: ['show', 'selectedAcu'],
    data: ()=>({
        mdiCheck,
        mdiClose,
        mdiCheckDecagram,
        mdiFileMoveOutline,
        loading: {
            save: false,
            requestForApproval: false
        },
        no_grace: 'No Grace Period',
        data: {
            'ACCT_N': null,
            'ACCT_M': null,
            'AEXP_D': null,
            'PDUN_D': null,
            'STATUS': null, // "A" for "ACTIVE", "I" for "INACTIVE"
            'STATUS_DATE': null, // Date UTC+8:00 or date string in format YYYY-MM-DD
            'ACTIVE_UNTIL': null, // Date in UTC+8:00 or date string in format YYYY-MM-DD
            'MEMB_MONTHS': null,
            'PAID_MONTHS': null,
            'PAID_MEMB_MONTHS': null,
            'PROVISION_EXPIRY': null, // Date UTC+0800 or Date String in format YYYY-MM-DD
            'USE_STORED_RATES': 'NO',
            'VALIDITY_DAYS': 14,
            'INT_REMARKS': null
        },
        rule: {
            month: [
                v => !isNaN(Number(v)) && Number.isInteger(Number(v)) || 'Must be a whole number',
                v => (v >= 0 && v <= 12) || 'Must be between 0 and 12'
            ],
            days: [
                v => !isNaN(Number(v)) && Number.isInteger(Number(v)) || 'Must be a whole number',
                v => (v >= 0) || 'Must be greater than 0'
            ]
        }
    }),
    computed: {
        ...mapGetters(['acuActiveListData', 'toggleAcuStatusData', 'toggleAcuProgressData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.resetData()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        toggleAcuProgressData(newVal) {
            if (newVal && newVal.status === 200) {
                // this.$emit('refreshAcuList', this.data.ACCT_N)
                this.$emit('closeDialog')
            }
        },
        toggleAcuStatusData(newVal) {
            if (newVal && newVal.status === 200) {
                // this.$emit('refreshAcuList', this.data.ACCT_N)
                this.$emit('closeDialog')
            }
        },
        selectedAcu: {
            handler(newVal) {
                if (newVal) {
                    this.data = structuredClone(newVal)
                    this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.formatDate(this.data.ACTIVE_UNTIL) : this.whichComesEarlier(this.selectedAcu.PDUN_D, this.selectedAcu.AEXP_D)
                    this.data.STATUS_DATE = this.data.STATUS_DATE ? this.formatDate(this.data.STATUS_DATE) : this.formatDate(new Date())
                    this.data.PROVISION_EXPIRY = this.data.PROVISION_EXPIRY ? this.formatDate(this.data.PROVISION_EXPIRY) : this.selectedAcu.AEXP_D
                    this.data.STATUS = this.data.STATUS === 'ACTIVE' ||  this.data.STATUS === 'PENDING' || this.data.STATUS === 'IN PROGRESS' ? 'ACTIVE' : 'INACTIVE'
                    this.data.USE_STORED_RATES = this.data.USE_STORED_RATES === 1 ? 'YES' : 'NO'
                    this.data.INT_REMARKS = newVal.INT_REMARKS
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        ...mapActions(['acuActiveList', 'toggleAcuStatus', 'toggleAcuProgress']),
        async handleRequestForApproval() {
            this.$refs.monthsOfContinuousMembership.blur()
            this.$refs.monthsOfPayment.blur()
            this.$refs.monthsActiveOnTheCurrentContractPeriod.blur()
            this.$nextTick(() => {
                if (this.$refs && this.$refs.form && this.$refs.form.validate()) {
                    this.$nextTick(async ()=>{
                        this.loading.requestForApproval = true
                        this.data.STATUS = this.data.STATUS === 'ACTIVE' ? 'A' : 'I'
                        this.data.STATUS_DATE = this.data.STATUS_DATE ? this.data.STATUS_DATE : new Date()
                        this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.data.ACTIVE_UNTIL : this.selectedAcu.AEXP_D
                        this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.data.ACTIVE_UNTIL : this.selectedAcu.AEXP_D
                        this.data.USE_STORED_RATES = this.data.USE_STORED_RATES === 'YES' ? 1 : 0
                        this.data.VALIDITY_DAYS = Number(this.data.VALIDITY_DAYS)
                        this.data.INT_REMARKS = this.data.INT_REMARKS ? String(this.data.INT_REMARKS).trim() : null
                        const tempData = {
                            ACCT_N: this.data.ACCT_N,
                            STATUS: this.data.STATUS,
                            STATUS_DATE: this.data.STATUS_DATE,
                            ACTIVE_UNTIL: this.data.ACTIVE_UNTIL,
                            MEMB_MONTHS: this.data.MEMB_MONTHS,
                            PAID_MONTHS: this.data.PAID_MONTHS,
                            PAID_MEMB_MONTHS: this.data.PAID_MEMB_MONTHS,
                            PROVISION_EXPIRY: this.data.PROVISION_EXPIRY,
                            USE_STORED_RATES: this.data.USE_STORED_RATES,
                            VALIDITY_DAYS: this.data.VALIDITY_DAYS,
                            INT_REMARKS: this.data.INT_REMARKS
                        }
                        await this.toggleAcuStatus(tempData)
                        if (this.toggleAcuStatusData.status === 200) {
                            const params = { ACCT_N: this.selectedAcu.ACCT_N, IN_PROGRESS: false }
                            await this.toggleAcuProgress(params)
                            if (this.toggleAcuProgressData.status === 200) {
                                this.$emit('refreshAcuList', this.data.ACCT_N)
                            }
                        }
                        this.loading.requestForApproval = false
                    })
                }
            })
        },
        async handleSaveWhenInProgress() {
            this.$refs.monthsOfContinuousMembership.blur()
            this.$refs.monthsOfPayment.blur()
            this.$refs.monthsActiveOnTheCurrentContractPeriod.blur()
            this.$nextTick(() => {
                if (this.$refs && this.$refs.form && this.$refs.form.validate()) {
                    this.$nextTick(async ()=>{
                        this.loading.save = true
                        this.data.STATUS = this.data.STATUS === 'ACTIVE' ? 'A' : 'I'
                        this.data.STATUS_DATE = this.data.STATUS_DATE ? this.data.STATUS_DATE : new Date()
                        this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.data.ACTIVE_UNTIL : this.selectedAcu.AEXP_D
                        this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.data.ACTIVE_UNTIL : this.selectedAcu.AEXP_D
                        this.data.USE_STORED_RATES = this.data.USE_STORED_RATES === 'YES' ? 1 : 0
                        this.data.VALIDITY_DAYS = Number(this.data.VALIDITY_DAYS)
                        this.data.INT_REMARKS = this.data.INT_REMARKS ? String(this.data.INT_REMARKS).trim() : null
                        const tempData = {
                            ACCT_N: this.data.ACCT_N,
                            STATUS: this.data.STATUS,
                            STATUS_DATE: this.data.STATUS_DATE,
                            ACTIVE_UNTIL: this.data.ACTIVE_UNTIL,
                            MEMB_MONTHS: this.data.MEMB_MONTHS,
                            PAID_MONTHS: this.data.PAID_MONTHS,
                            PAID_MEMB_MONTHS: this.data.PAID_MEMB_MONTHS,
                            PROVISION_EXPIRY: this.data.PROVISION_EXPIRY,
                            USE_STORED_RATES: this.data.USE_STORED_RATES,
                            VALIDITY_DAYS: this.data.VALIDITY_DAYS,
                            INT_REMARKS: this.data.INT_REMARKS
                        }
                        await this.toggleAcuStatus(tempData)
                        if (this.toggleAcuStatusData.status === 200) {
                            this.$emit('refreshAcuList', this.data.ACCT_N)
                        }
                        this.loading.save = false
                    })
                }
            })
        },
        async handleMoveToInProgress(IN_PROGRESS) {
            this.loading.requestForApproval = true
            const params = { ACCT_N: this.selectedAcu.ACCT_N, IN_PROGRESS }
            await this.toggleAcuProgress(params)
            if (this.toggleAcuProgressData.status === 200) {
                this.$emit('refreshAcuList', this.data.ACCT_N)
            }
            this.loading.requestForApproval = false
        },
        handleChangeDate() {
            this.$nextTick(()=>{
                this.$refs.activeUntil.validate()
                this.$refs.statusDate.validate()
            })
        },
        resetData() {
            this.data = structuredClone(this.selectedAcu)
            this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.formatDate(this.data.ACTIVE_UNTIL) : this.whichComesEarlier(this.selectedAcu.PDUN_D, this.selectedAcu.AEXP_D)
            this.data.STATUS_DATE = this.data.STATUS_DATE ? this.formatDate(this.data.STATUS_DATE) : this.formatDate(new Date())
            this.data.PROVISION_EXPIRY = this.data.PROVISION_EXPIRY ? this.formatDate(this.data.PROVISION_EXPIRY) : this.selectedAcu.AEXP_D
            this.data.STATUS = this.data.STATUS === 'ACTIVE' ||  this.data.STATUS === 'PENDING' || this.data.STATUS === 'IN PROGRESS' ? 'ACTIVE' : 'INACTIVE'
            this.data.USE_STORED_RATES = this.data.USE_STORED_RATES === 1 ? 'YES' : 'NO'
            this.data.INT_REMARKS = this.selectedAcu.INT_REMARKS
        },
        formatDate(date) {
            return moment(date).utcOffset('+0800').format('YYYY-MM-DD')
        },
        isDateAllowed(value, pdun_d, aexp_d) {
            let compareByPayment = moment(value).utcOffset('+0800').startOf('day').isSameOrBefore(moment(pdun_d).utcOffset('+0800').startOf('day'))
            let compateByAccountExpiry = moment(value).utcOffset('+0800').startOf('day').isSameOrBefore(moment(aexp_d).utcOffset('+0800').startOf('day'))
            return compareByPayment && compateByAccountExpiry
        },
        whichComesEarlier(date_1, date_2) {

            if (date_1 && date_2) {
                let date_1_moment = moment(date_1).utcOffset('+0800').startOf('day')
                let date_2_moment = moment(date_2).utcOffset('+0800').startOf('day')

                if (date_1_moment.isBefore(date_2_moment)) {
                    return date_1
                } else {
                    return date_2
                }

            } else if (date_1 === undefined || date_1 === null) {
                return date_2
            } else {
                return date_1
            }

        },
        switchPaidUntilOrGracePeriod(pdun_d, grcp_d) {
            if (grcp_d && String(grcp_d).trim()) {
                return grcp_d
            } else {
                return pdun_d
            }
        },
        async submitForm() {
            this.$refs.monthsOfContinuousMembership.blur()
            this.$refs.monthsOfPayment.blur()
            this.$refs.monthsActiveOnTheCurrentContractPeriod.blur()
            this.$nextTick(() => {
                if (this.$refs.form.validate()) {
                    this.$nextTick(async ()=>{
                        this.loading.save = true
                        this.data.STATUS = this.data.STATUS === 'ACTIVE' ? 'A' : 'I'
                        // this.data.STATUS = 'I'
                        this.data.STATUS_DATE = this.data.STATUS_DATE ? this.data.STATUS_DATE : new Date()
                        this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.data.ACTIVE_UNTIL : this.selectedAcu.AEXP_D
                        this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.data.ACTIVE_UNTIL : this.selectedAcu.AEXP_D
                        this.data.USE_STORED_RATES = this.data.USE_STORED_RATES === 'YES' ? 1 : 0
                        this.data.VALIDITY_DAYS = Number(this.data.VALIDITY_DAYS)
                        this.data.INT_REMARKS = this.data.INT_REMARKS ? String(this.data.INT_REMARKS).trim() : null
                        const tempData = {
                            ACCT_N: this.data.ACCT_N,
                            STATUS: this.data.STATUS,
                            STATUS_DATE: this.data.STATUS_DATE,
                            ACTIVE_UNTIL: this.data.ACTIVE_UNTIL,
                            MEMB_MONTHS: this.data.MEMB_MONTHS,
                            PAID_MONTHS: this.data.PAID_MONTHS,
                            PAID_MEMB_MONTHS: this.data.PAID_MEMB_MONTHS,
                            PROVISION_EXPIRY: this.data.PROVISION_EXPIRY,
                            USE_STORED_RATES: this.data.USE_STORED_RATES,
                            VALIDITY_DAYS: this.data.VALIDITY_DAYS,
                            INT_REMARKS: this.data.INT_REMARKS
                        }
                        await this.toggleAcuStatus(tempData)
                        this.$emit('refreshAcuList', this.data.ACCT_N)
                        this.loading.save = false
                    })
                }
            })
        }
    }
}
</script>

<style>
.update-acu-contract-blue-hint .v-input__control .v-text-field__details .v-messages .v-messages__wrapper .v-messages__message {
    color: #009688; /* Vuetify primary blue or any shade you prefer */
}
</style>
